import BasePage from "@/infrastructure/BasePage/basePage.component";
import { Card } from "@/shadcn/components/ui/card";
const HomePage = () => {
  return (
    <BasePage currPage="home">
      <Card className="flex flex-col w-full h-full overflow-hidden rounded-sm dark:bg-background">
        <h1 className="text-3xl font-bold text-center text-primary mt-3 ">
          Welcome to Beone SuperCharged
        </h1>
      </Card>
    </BasePage>
  );
};

export default HomePage;
